import React from 'react';

const ROLES = ['examined', 'reference'];
const roleLabel = role => role === 'reference' ? 'Version de référence' : 'Version examinée';
const versionLabel = version => `${version.version} · ${version.title || version.document_version_id}`;

export function getVersionEvidence(metadata) {
    const pair = metadata?.comparison_version_pair;
    const provenance = metadata?.comparison_provenance;
    if (pair?.reference_type !== 'document_version') return null;
    if (!provenance?.request_fingerprint || !pair.reference || !pair.examined
        || !pair.reference.document_version_id || !pair.examined.document_version_id
        || pair.reference.document_version_id === pair.examined.document_version_id) return {error: true};

    const evidence = Array.isArray(provenance.evidence) ? provenance.evidence : [];
    if (!provenance.reference || !provenance.examined || evidence.some(item => {
        const pairedVersion = pair[item?.role];
        const pairedProvenance = provenance[item?.role];
        return !ROLES.includes(item?.role)
            || !pairedVersion
            || !pairedProvenance
            || item.document_version_id !== pairedVersion.document_version_id
            || item.document_id !== pairedVersion.document_id
            || item.content_sha256 !== pairedProvenance.content_sha256;
    })) return {error: true};

    return {pair, evidence, fingerprint: provenance.request_fingerprint};
}

const representativeEvidence = (evidence, role) => evidence
    .filter(item => item.role === role)
    .sort((left, right) => Number(Boolean(right.bbox)) - Number(Boolean(left.bbox)))[0] || null;

export default function ComparisonVersionEvidence({metadata, onEvidenceOpen}) {
    const projection = getVersionEvidence(metadata);
    if (!projection) return null;
    if (projection.error) {
        return <p className="comparison-version-evidence__error" role="alert">Provenance de la comparaison indisponible. Aucun document de remplacement ne sera ouvert.</p>;
    }

    const {pair, evidence, fingerprint} = projection;
    const entries = ROLES.map(role => ({
        role,
        version: pair[role],
        evidence: representativeEvidence(evidence, role),
    })).filter(entry => entry.evidence);

    return <section className="comparison-version-evidence" aria-label="Versions et preuves">
        <div className="comparison-version-evidence__pair">
            <span>Référence : <strong>{versionLabel(pair.reference)}</strong></span>
            <span aria-hidden="true">→</span>
            <span>Version examinée : <strong>{versionLabel(pair.examined)}</strong></span>
        </div>
        <div className="comparison-version-evidence__actions">
            {entries.map(({role, version, evidence: item}) => {
                const page = Number(item.page);
                const pageLabel = Number.isInteger(page) && page > 0 ? `page ${page}` : 'ouvrir le document';
                return <button
                    type="button"
                    className="comparison-version-evidence__action"
                    key={role}
                    onClick={(event) => {
                        event.stopPropagation();
                        const detail = {evidence: item, version, fingerprint};
                        if (onEvidenceOpen) {
                            onEvidenceOpen(detail);
                        } else if (typeof window !== 'undefined') {
                            window.dispatchEvent(new CustomEvent('verdictia:comparison-version-evidence-open', {detail}));
                        }
                    }}
                    aria-label={`${roleLabel(role)}, ${pageLabel}${item.excerpt ? ` : ${item.excerpt}` : ''}`}
                >
                    <span className="comparison-version-evidence__action-label">{roleLabel(role)} · {pageLabel}</span>
                    {item.excerpt && <span className="comparison-version-evidence__excerpt">{item.excerpt}</span>}
                </button>;
            })}
        </div>
    </section>;
}
